import type { BoxProps } from '@mui/material/Box';

import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import NoSsr from '@mui/material/NoSsr';
import { styled } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { CONFIG } from 'src/config-global';

import { logoClasses } from './classes';

export type LogoProps = BoxProps & {
  href?: string;
  disableLink?: boolean;
};

const LogoWrapper = styled('img')(() => ({
  width: 200,
  objectFit: 'contain',
}));

export const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    { width = 100, height = 100, disableLink = false, className, href = '/', sx, ...other },
    ref
  ) => (
    <NoSsr
      fallback={
        <Box
          width={width}
          height={height}
          className={logoClasses.root.concat(className ? ` ${className}` : '')}
          sx={{ flexShrink: 0, display: 'inline-flex', verticalAlign: 'middle', ...sx }}
        />
      }
    >
      <Box
        ref={ref}
        component={RouterLink}
        href={href}
        width="100%"
        height={height}
        className={logoClasses.root.concat(className ? ` ${className}` : '')}
        aria-label="logo"
        sx={{
          flexShrink: 0,
          display: 'inline-flex',
          verticalAlign: 'middle',
          ...(disableLink && { pointerEvents: 'none' }),
          ...sx,
        }}
        {...other}
      >
        <LogoWrapper
          src={`${CONFIG.site.basePath}/logo/logo-baf.png`}
          alt="BAF logo"
        />
      </Box>
    </NoSsr>
  )
);
